import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
export var LY_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return LyCheckbox; }),
    multi: true
};
export var CheckboxState;
(function (CheckboxState) {
    /** The initial state. */
    CheckboxState[CheckboxState["Init"] = 0] = "Init";
    /** Checked state. */
    CheckboxState[CheckboxState["Checked"] = 1] = "Checked";
    /** Unchecked state. */
    CheckboxState[CheckboxState["Unchecked"] = 2] = "Unchecked";
    /** Indeterminate state. */
    CheckboxState[CheckboxState["Indeterminate"] = 3] = "Indeterminate";
})(CheckboxState || (CheckboxState = {}));
var LyCheckbox = /** @class */ (function () {
    function LyCheckbox() {
        this._currentCheckState = CheckboxState.Init;
        this.checked = false;
        this.change = new EventEmitter();
        this.indeterminateChange = new EventEmitter();
        this.onTouched = function () { };
        this._controlValueAccessorChangeFn = function (value) { };
    }
    /** Toggles the `checked` state of the checkbox. */
    /** Toggles the `checked` state of the checkbox. */
    LyCheckbox.prototype.toggle = /** Toggles the `checked` state of the checkbox. */
    function () {
        this.checked = !this.checked;
    };
    LyCheckbox.prototype._onChangeEvent = function (event) {
        event.stopPropagation();
    };
    LyCheckbox.prototype._onInputClick = function (event) {
        var ev = event.target;
        this.checked = ev.checked;
        this._controlValueAccessorChangeFn(this.checked);
        console.log('_onInputClick', ev.checked);
    };
    LyCheckbox.prototype.writeValue = function (value) {
        this.checked = !!value;
        console.log('value', this.checked);
    };
    LyCheckbox.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    LyCheckbox.prototype.ngOnChanges = function (changes) {
        console.log('changes', changes);
        if (changes['src']) {
            // fn
        }
    };
    LyCheckbox.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    LyCheckbox.prototype.ngOnInit = function () {
    };
    LyCheckbox.prototype.ngAfterContentInit = function () {
    };
    LyCheckbox.prototype.ngOnDestroy = function () {
    };
    LyCheckbox.decorators = [
        { type: Component, args: [{
                    selector: 'ly-checkbox',
                    template: "<label> <div class=\"ly-checkbox-container\"> <input #input [hidden]=\"false\" type=\"checkbox\" [id]=\"id\" [required]=\"required\" [checked]=\"checked\" [value]=\"value\" [disabled]=\"disabled\" [name]=\"name\" [indeterminate]=\"indeterminate\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onChangeEvent($event)\" (click)=\"_onInputClick($event)\"> </div> </label> ",
                    styles: [":host { display: inline-block; } "],
                    providers: [LY_CHECKBOX_CONTROL_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    LyCheckbox.ctorParameters = function () { return []; };
    LyCheckbox.propDecorators = {
        "id": [{ type: Input, args: ['id',] },],
        "ariaLabel": [{ type: Input, args: ['attr.aria-label',] },],
        "ariaLabelledby": [{ type: Input, args: ['attr.aria-labelledby',] },],
        "required": [{ type: Input, args: ['required',] },],
        "labelPosition": [{ type: Input, args: ['labelPosition',] },],
        "color": [{ type: Input, args: ['color',] },],
        "value": [{ type: Input, args: ['value',] },],
        "name": [{ type: Input, args: ['name',] },],
        "disabled": [{ type: Input, args: ['disabled',] },],
        "checked": [{ type: Input, args: ['checked',] },],
        "indeterminate": [{ type: Input, args: ['indeterminate',] },],
        "change": [{ type: Output, args: ['change',] },],
        "indeterminateChange": [{ type: Output, args: ['indeterminateChange',] },],
    };
    return LyCheckbox;
}());
export { LyCheckbox };
//# sourceMappingURL=ly-checkbox.component.js.map